"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
const en_ca = {
    required: "This field is required.",
    recaptchaRequired: "Please complete the ReCAPTCHA.",
    passwordMinLength: "Password must contain at least 8 characters.",
    passwordRequirements: "Your password must contain the following elements: lowercase letters, uppercase letters, numbers, and special characters.",
    passwordMismatch: "Passwords do not match.",
    wrongEmailFormat: "Please enter a valid email address (Ex: johndoe@domain.com).",
    wrongPhoneNumberFormat: "Please enter a valid phone number (Ex: (111) 111-1111).",
    wrongPostalCodeFormat: "Please enter a valid postal code (Ex: G1G 1G1).",
    wrongZipCodeFormat: "Please enter a valid zip code (Ex: 12345).",
    defaultFormError: "An error has occurred. Please check your form and try again.",
    recaptcha: "Please complete the ReCAPTCHA.",
    token: "A token is required.",
    tokenFail: "An error occurred while processing the password change",
    magento: {
        emailAlreadyTaken: "This email address is already used.",
        invalidCredentials: "Invalid login credentials.",
    },
};
const fr_ca = {
    required: "Ce champ est requis.",
    recaptchaRequired: "Veuillez compléter le ReCAPTCHA.",
    passwordMinLength: "Le mot de passe doit contenir au moins 8 caractères.",
    passwordRequirements: "Votre mot de passe doit contenir les éléments suivants: minuscules, majuscules, chiffres, caractères spéciaux.",
    passwordMismatch: "Les mots de passe ne correspondent pas.",
    wrongEmailFormat: "Veuillez saisir une adresse courriel valide (Ex: johndoe@domaine.com).",
    wrongPhoneNumberFormat: "Veuillez saisir un numéro de téléphone valide (Ex: (111) 111-1111).",
    wrongPostalCodeFormat: "Veuillez saisir un code postal valide (Ex: G1G 1G1).",
    wrongZipCodeFormat: "Veuillez saisir un code zip valide (Ex: 12345).",
    defaultFormError: "Une erreur s'est produite. Veuillez vérifier votre formulaire et réessayer.",
    recaptcha: "Veuillez compléter le ReCAPTCHA.",
    token: "Un jeton est requis.",
    tokenFail: "Une erreur s'est produite lors du traitement du changement de mot de passe.",
    magento: {
        emailAlreadyTaken: "Cette adresse de courriel est déjà utilisée. ",
        invalidCredentials: "Identifiants de connexion invalides.",
    },
};
const en_us = {
    required: "This field is required.",
    recaptchaRequired: "Please complete the ReCAPTCHA.",
    passwordMinLength: "Password must contain at least 8 characters.",
    passwordRequirements: "Your password must contain the following elements: lowercase letters, uppercase letters, numbers, and special characters.",
    passwordMismatch: "Passwords do not match.",
    wrongEmailFormat: "Please enter a valid email address (Ex: johndoe@domain.com).",
    wrongPhoneNumberFormat: "Please enter a valid phone number (Ex: (111) 111-1111).",
    wrongPostalCodeFormat: "Please enter a valid postal code (Ex: G1G 1G1).",
    wrongZipCodeFormat: "Please enter a valid zip code (Ex: 12345).",
    defaultFormError: "An error has occurred. Please check your form and try again.",
    recaptcha: "Please complete the ReCAPTCHA.",
    token: "A token is required.",
    tokenFail: "An error occurred while processing the password change",
    magento: {
        emailAlreadyTaken: "This email address is already used.",
        invalidCredentials: "Invalid login credentials.",
    },
};
exports.translations = {
    fr_CA: fr_ca,
    en_CA: en_ca,
    en_US: en_us,
};
//# sourceMappingURL=inputErrorTranslations.js.map